
/* Copyright (c) 2017 Backpack Health LLC */

import React, { FC } from 'react';

import MedliAmountText from './MedliAmountText';
import FrequencyText from './FrequencyText';
import { HealthEntry } from '../../models/HealthEntry';

const formatAmount = (healthEntry, languageCode) => (
  <MedliAmountText
    amount={healthEntry.amount.get()}
    description={healthEntry.description ? healthEntry.description.get() : null}
    languageCode={languageCode}
  />
);

const formatFrequency = (healthEntry) => (
  <FrequencyText
    frequencyData={healthEntry.frequency.get()}
  />
);

const getAmountFrequencyValue = (healthEntry, languageCode) => {
  const hasAmount = healthEntry.amount && healthEntry.amount.hasAmount();
  const hasFrequency = healthEntry.frequency && healthEntry.frequency.hasFrequency();

  if (hasAmount && hasFrequency) {
    return (
      <span>
        {formatAmount(healthEntry, languageCode)}, <span style={{ textTransform: 'lowercase' }}>{formatFrequency(healthEntry)}</span>
      </span>
    );
  } else if (hasAmount) {
    return formatAmount(healthEntry, languageCode);
  } else if (hasFrequency) {
    return formatFrequency(healthEntry);
  } else {
    return null;
  }
};

interface Props {
  healthEntry: HealthEntry;
  languageCode: string;
}

class MedliAmountAndFrequencyText extends React.Component<Props> {

  static renderIfAmountOrFrequency(healthEntry, languageCode) {
    const hasAmount = healthEntry.amount && healthEntry.amount.hasAmount();
    const hasFrequency = healthEntry.frequency && healthEntry.frequency.hasFrequency();
    return hasAmount || hasFrequency
      ? <MedliAmountAndFrequencyText healthEntry={healthEntry} languageCode={languageCode} />
      : null;
  }

  render() {
    const { healthEntry, languageCode } = this.props;
    return getAmountFrequencyValue(healthEntry, languageCode);
  }
}

export default MedliAmountAndFrequencyText;
